import React, { useState, useEffect, useRef } from "react";
import "@avaya/neo-react/avaya-neo-react.css";
import Sdk from "../DialerComponent/Sdk";
import "../../assets/assets/dist/css/neo/neo.css";
import "./navbar.css";
import { connect } from "react-redux";

import {
  setcontactlist,
  setcontactlist1,
  closeNotify,
  clearnotifyAll,
  setShowNotification,
  setShowUserProfile,
  setshowphonedialer,
  setVoiceRefresh,
  setsidebarVal,
  setReadyButton,
  setShowingStatus,
  setShowingStatusVoice,
  setShowingStatusClass,
  updateNotification,
} from "../../redux/actions/actions";
import {
  BaseUrl,
  frontendBaseurl,
  errorApi,
  versionCode,
  logoutTime,
} from "../../container/BaseUrl/BaseUrl";
import axios from "axios";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  ArrowsClockwise,
  SealCheck,
  SignOut,
  WifiHigh,
  WifiX,
} from "@phosphor-icons/react";
import InternetError from "../InternetError-component/useOnlineStatus ";
import { Button, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";

const mapStateToProps = (state) => {
  return {
    contactList: state.contactListData.contactList,
    notification: state.notification.notification,
    showNotification: state.data.showNotification,
    showUserProfile: state.data.showUserProfile,
    showphonedialer: state.data.showphonedialer,
    VoiceRefresh: state.data.VoiceRefresh,
    readyButton: state.contactListData.readyButton,
    showingStatus: state.contactListData.showingStatus,
    showingStatusVoice: state.contactListData.showingStatusVoice,
    showingStatusClass: state.contactListData.showingStatusClass,
  };
};

const Navbar = (props) => {
  const { showingStatus, showingStatusVoice, showingStatusClass, readyButton } =
    props;
  const AvcUrl = localStorage.getItem("AvcUrl");
  const [agentName, setagentName] = useState("null");
  const [agentEmail, setagentEmail] = useState("null");
  const [goReadyButtonDisable, setgoReadyButtonDisable] = useState(false);
  const [showReasonCode, setshowReasonCode] = useState(false);
  const [userstatus, setUserstatus] = useState([]);
  const [invoice, setinvoice] = useState(false);
  const [dailedNumber, setDialedNumber] = useState("");
  const channel = JSON.parse(localStorage.getItem("tokenAgent"));
  const filteredChannels = channel
    ? channel.channel.filter((item) => !item.parentClientChannelId)
    : "";
  const { isOnline, showNotification } = InternetError();
  const timeoutRef = useRef(null);
  const [isActive, setIsActive] = useState(true);
  const navigate = useNavigate();
  useEffect(() => {
    filteredChannels.map((item) => {
      if (item.channelName == "Voice") {
        localStorage.setItem("voiceEnable", "true");
      }
    });

    let name = localStorage.getItem("NameDisplay");
    let email = localStorage.getItem("emailDisplay");

    if (name) {
      setagentName(name.substring(0, 2).toLocaleUpperCase());
      setagentEmail(email);
    }
  }, []);

  useEffect(() => {
    const resetTimeout = () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      timeoutRef.current = setTimeout(() => {
        setIsActive(false);
      }, logoutTime);
    };
    const handleUserActivity = () => {
      setIsActive(true);
      resetTimeout();
    };
    resetTimeout();
    document.addEventListener("mousemove", handleUserActivity);
    document.addEventListener("keydown", handleUserActivity);
    return () => {
      clearTimeout(timeoutRef.current);
      document.removeEventListener("mousemove", handleUserActivity);
      document.removeEventListener("keydown", handleUserActivity);
    };
  }, []);

  useEffect(() => {
    if (!isActive) {
      changeStatusVoice(
        localStorage.getItem("VoiceCallStatus"),
        localStorage.getItem("VoiceCallStatus")
      );
    }
  }, [isActive]);

  const show_notification = () => {
    props.setShowNotification(!props.showNotification);
    props.setShowUserProfile(false);
    props.setshowphonedialer(false);
  };
  const close_notification = () => {
    props.setShowNotification(false);
  };
  const show_userprofile = () => {
    if (invoice) {
    } else {
      props.setShowUserProfile(!props.showUserProfile);
      props.setShowNotification(false);
    }
  };
  const close_userprofile = () => {
    props.setShowUserProfile(false);
  };
  const logout = async () => {
    let data = JSON.parse(localStorage.getItem("tokenAgent"));
    let userID = data.user_id;
    if (data) {
      await axios
        .post(
          BaseUrl + "/users/logoutnew/" + userID,
          {},
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("access_token"),
              "Content-Type": "application/json",
              tenantId: localStorage.getItem("TenantId"),
            },
          }
        )
        .then((res) => {
          if (res.data.success == true) {
            localStorage.removeItem("AvayaUsername");
            localStorage.removeItem("tab");
            localStorage.removeItem("timer_connect_sec");
            localStorage.removeItem("AvayaPassword");
            localStorage.removeItem("AvayaDomain");
            localStorage.removeItem("client");
            localStorage.removeItem("statusValue");
            localStorage.removeItem("emailDisplay");
            localStorage.removeItem("timer_connect_min");
            localStorage.removeItem("tokenAgent");
            localStorage.removeItem("timer_status");
            localStorage.removeItem("NameDisplay");
            localStorage.removeItem("access_token");
            localStorage.removeItem("timer_connect_hour");
            localStorage.removeItem("EnableWEBRTC");
            localStorage.removeItem("ticketcrm");
            if (!localStorage.getItem("TenantId")) {
              window.location.href = "error.html";
            } else {
              const loginUrl = `${frontendBaseurl}/?tenantID=${encodeURIComponent(
                localStorage.getItem("TenantId")
              )}`;
              window.location.href = loginUrl;
            }
          } else {
            toast.warn("Please Close all Active Sessions", {
              position: "top-right",
              autoClose: 500,
              hideProgressBar: true,
              closeOnClick: false,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              theme: "light",
            });
          }
        })
        .catch((err) => {});
    }
  };
  const loginbyDomain = async () => {
    if (localStorage.getItem("voiceEnable") == "true") {
      await axios
        .post(
          AvcUrl +
            `/voice/cct/login?username=${localStorage.getItem(
              "AvayaUsername"
            )}&password=${localStorage.getItem(
              "AvayaPassword"
            )}&domain=${localStorage.getItem("AvayaDomain")}`,
          {},
          {
            headers: {
              tenantId: localStorage.getItem("TenantId"),
            },
          }
        )
        .then(async (res) => {
          if ((res.data.status = "OK")) {
            localStorage.setItem("enableSDK", "true");
            localStorage.setItem("ssoToken", res.data.data.ssoToken);
            localStorage.setItem(
              "agentLoginTerminalId",
              res.data.data.agents[0].agentLoginId
            );
            localStorage.setItem(
              "agentUsername",
              res.data.data.agents[0].agentUsername
            );
            loginbyDomainforAgent(
              res.data.data.agents[0].agentLoginId,
              res.data.data.ssoToken,
              res.data.data.agents[0].agentUsername
            );
          } else {
            let data = await JSON.parse(localStorage.getItem("tokenAgent"));
            await axios
              .post(
                BaseUrl + "/users/updateAgentStatus/",
                {
                  status: "Ready",
                  userId: data.user_id,
                },
                {
                  headers: {
                    Authorization:
                      "Bearer " + localStorage.getItem("access_token"),
                    "Content-Type": "application/json",
                    tenantId: localStorage.getItem("TenantId"),
                  },
                }
              )
              .then((res) => {
                if (res.data.status) {
                  setgoReadyButtonDisable(false);
                  props.setShowingStatus("Ready");
                  localStorage.setItem("AgentStatus", "Ready");
                  props.setShowingStatusClass("showStatus");
                  props.setShowingStatusVoice("Not Connected");
                  props.setReadyButton(true);
                } else {
                  setgoReadyButtonDisable(false);
                  props.setShowingStatus("Connected");
                  localStorage.setItem("AgentStatus", "Connected");
                  props.setShowingStatusClass("showStatusConnected");
                  props.setShowingStatusVoice("Connected");
                  props.setReadyButton(false);
                  toast.warn("Please Try Again After Some Time", {
                    position: "top-right",
                    autoClose: 500,
                    hideProgressBar: true,
                    closeOnClick: false,
                    pauseOnHover: false,
                    draggable: false,
                    progress: undefined,
                    theme: "light",
                  });
                }
              })
              .catch((err) => {
                setgoReadyButtonDisable(false);
                props.setShowingStatus("Connected");
                localStorage.setItem("AgentStatus", "Connected");
                props.setShowingStatusClass("showStatusConnected");
                props.setShowingStatusVoice("Connected");
                props.setReadyButton(false);
                toast.warn("Please Try Again After Some Time", {
                  position: "top-right",
                  autoClose: 500,
                  hideProgressBar: true,
                  closeOnClick: false,
                  pauseOnHover: false,
                  draggable: false,
                  progress: undefined,
                  theme: "light",
                });
              });
            ErrorNotification("Voice LogIn", res.data.message);
          }
        })
        .catch(async (error) => {
          let data = await JSON.parse(localStorage.getItem("tokenAgent"));
          await axios
            .post(
              BaseUrl + "/users/updateAgentStatus/",
              {
                status: "Ready",
                userId: data.user_id,
              },
              {
                headers: {
                  Authorization:
                    "Bearer " + localStorage.getItem("access_token"),
                  "Content-Type": "application/json",
                  tenantId: localStorage.getItem("TenantId"),
                },
              }
            )
            .then((res) => {
              if (res.data.status) {
                setgoReadyButtonDisable(false);
                props.setShowingStatus("Ready");
                props.setShowingStatusClass("showStatus");
                localStorage.setItem("AgentStatus", "Ready");
                props.setShowingStatusVoice("Not Connected");
                props.setReadyButton(true);
              } else {
                setgoReadyButtonDisable(false);
                props.setShowingStatus("Connected");
                localStorage.setItem("AgentStatus", "Connected");
                props.setShowingStatusClass("showStatusConnected");
                props.setShowingStatusVoice("Connected");
                props.setReadyButton(false);
                toast.warn("Please Try Again After Some Time", {
                  position: "top-right",
                  autoClose: 500,
                  hideProgressBar: true,
                  closeOnClick: false,
                  pauseOnHover: false,
                  draggable: false,
                  progress: undefined,
                  theme: "light",
                });
              }
            })
            .catch((err) => {
              setgoReadyButtonDisable(false);
              props.setShowingStatus("Connected");
              localStorage.setItem("AgentStatus", "Connected");
              props.setShowingStatusClass("showStatusConnected");
              props.setShowingStatusVoice("Connected");
              props.setReadyButton(false);
              toast.warn("Please Try Again After Some Time", {
                position: "top-right",
                autoClose: 500,
                hideProgressBar: true,
                closeOnClick: false,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: "light",
              });
            });

          ErrorNotification("Voice LogIn", res.data.message);
        });
    } else {
      updateStatus("Ready");
    }
  };
  const loginbyDomainforAgent = async (terminalId, ssoToken, agentUsername) => {
    if (!terminalId && !ssoToken) return;
    await axios
      .post(
        AvcUrl +
          `/voice/cct/agent/${terminalId}/login/${terminalId}?status=Ready`,
        {},
        {
          headers: {
            ssoToken: ssoToken,
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then(async (res) => {
        if ((res.data.status = "OK")) {
          let data = JSON.parse(localStorage.getItem("tokenAgent"));
          await axios
            .post(
              BaseUrl + "/users/updateAgentStatus/",
              {
                status: "Ready",
                userId: data.user_id,
                agentLoginTerminalId: terminalId,
                agentUsername: agentUsername,
              },
              {
                headers: {
                  Authorization:
                    "Bearer " + localStorage.getItem("access_token"),
                  "Content-Type": "application/json",
                  tenantId: localStorage.getItem("TenantId"),
                },
              }
            )
            .then((res) => {
              if (res.data.status) {
                setgoReadyButtonDisable(false);
                props.setShowingStatus("Ready");
                localStorage.setItem("AgentStatus", "Ready");
                props.setShowingStatusClass("showStatus");
                props.setShowingStatusVoice("Ready");
                props.setReadyButton(true);

                setTimeout(() => {
                  window.location.reload(true);
                }, 1000);
              } else {
                setgoReadyButtonDisable(false);
                props.setShowingStatus("Connected");
                localStorage.setItem("AgentStatus", "Connected");
                props.setShowingStatusClass("showStatusConnected");
                props.setShowingStatusVoice("Connected");
                props.setReadyButton(false);
                toast.warn("Please Try Again After Some Time", {
                  position: "top-right",
                  autoClose: 500,
                  hideProgressBar: true,
                  closeOnClick: false,
                  pauseOnHover: false,
                  draggable: false,
                  progress: undefined,
                  theme: "light",
                });
              }
            })
            .catch((err) => {
              setgoReadyButtonDisable(false);
              props.setShowingStatus("Connected");
              localStorage.setItem("AgentStatus", "Connected");
              props.setShowingStatusClass("showStatusConnected");
              props.setShowingStatusVoice("Connected");
              props.setReadyButton(false);
              toast.warn("Please Try Again After Some Time", {
                position: "top-right",
                autoClose: 500,
                hideProgressBar: true,
                closeOnClick: false,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: "light",
              });
            });
        } else {
          updateStatus("Ready");
          props.setShowingStatusVoice("Not Connected");
          ErrorNotification("Voice LogIn", res.data.message);
        }
      })
      .catch((error) => {
        updateStatus("Ready");
        props.setShowingStatusVoice("Not Connected");
        ErrorNotification("Voice LogIn", error.message);
      });
  };
  const logoutByDomainFirst = async () => {
    if (localStorage.getItem("voiceEnable") == "true") {
      await axios
        .post(
          AvcUrl +
            `/voice/cct/agent/${localStorage.getItem(
              "agentLoginTerminalId"
            )}/logout/${localStorage.getItem("agentLoginTerminalId")}`,
          {},
          {
            headers: {
              ssoToken: localStorage.getItem("ssoToken"),
              tenantId: localStorage.getItem("TenantId"),
            },
          }
        )
        .then((res) => {
          if (res.data.status == "OK") {
            logoutByDomainSecond();
          } else {
            setgoReadyButtonDisable(false);
            updateStatus("Connected");
            ErrorNotification("Voice LogOut", res.data.message);
          }
        })
        .catch((error) => {
          setgoReadyButtonDisable(false);
          updateStatus("Connected");
          ErrorNotification("Voice LogOut", error.message);
        });
    } else {
      updateStatus("Connected");
    }
  };
  const logoutByDomainSecond = async () => {
    const agentUsername = localStorage.getItem("agentUsername");
    await axios
      .post(
        AvcUrl + "/voice/cct/logout?username=" + agentUsername,
        {},
        {
          headers: {
            ssoToken: localStorage.getItem("ssoToken"),
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        if (res.data.status == "OK") {
          setgoReadyButtonDisable(false);
          updateStatus("Connected");
          setTimeout(() => {
            window.location.reload(true);
          }, 2000);
        } else {
          setgoReadyButtonDisable(false);
          updateStatus("Connected");
          ErrorNotification("Voice LogOut", res.data.message);
        }
      })
      .catch((err) => {
        setgoReadyButtonDisable(false);
        updateStatus("Connected");
        ErrorNotification("Voice LogOut", err.message);
      });
  };
  const updateStatus = async (value) => {
    if (!value) return;
    let data = await JSON.parse(localStorage.getItem("tokenAgent"));
    await axios
      .post(
        BaseUrl + "/users/updateAgentStatus/",
        {
          status: value,
          userId: data.user_id,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        setgoReadyButtonDisable(false);
        props.setVoiceRefresh(false);
        if (res.data.status) {
          if (value == "Connected") {
            props.setShowingStatus(value);
            localStorage.setItem("AgentStatus", value);
            props.setShowingStatusClass("showStatusConnected");
            props.setShowingStatusVoice("Connected");
            localStorage.removeItem("ssoToken");
            localStorage.removeItem("agentLoginTerminalId");
            localStorage.removeItem("agentUsername");
            localStorage.removeItem("statusValue");
            localStorage.removeItem("enableSDK");
            props.setReadyButton(false);
          } else if (value == "Ready") {
            props.setReadyButton(true);
            props.setShowingStatus(value);
            localStorage.setItem("AgentStatus", value);
            props.setShowingStatusClass("showStatus");
            if (showingStatusVoice == "Not Connected") {
            } else {
              changeStatusVoice("Ready", "Ready");
            }
          } else {
            props.setReadyButton(true);
            props.setShowingStatus(value);
            localStorage.setItem("AgentStatus", "Not Ready");
            props.setShowingStatusClass("showStatusRed");
            if (showingStatusVoice == "Not Connected") {
            } else {
              if(value == 'Not Ready'){
                changeStatusVoice("Not Ready", "Not Ready");
              }
            }
          }
        }
      })
      .catch((err) => {
        setgoReadyButtonDisable(false);
      });
  };
  const changeStatusVoice = async (status, value2) => {
    if (
      localStorage.getItem("voiceEnable") == "true" &&
      localStorage.getItem("ssoToken")
    ) {
      await axios
        .post(
          AvcUrl +
            `/voice/cct/agent/${localStorage.getItem(
              "agentLoginTerminalId"
            )}/status?status=${status}`,
          {},
          {
            headers: {
              ssoToken: localStorage.getItem("ssoToken")
                ? localStorage.getItem("ssoToken")
                : "",
              tenantId: localStorage.getItem("TenantId"),
            },
          }
        )
        .then((res) => {
          if (res.data.status == "OK") {
            localStorage.setItem("VoiceStatuslastApiCallTime", Date.now());
            props.setShowingStatusVoice(value2);
            if (status == "Ready") {
              localStorage.removeItem("VoiceActivate");
            }
          } else {
            ErrorNotification("Voice Status", res.data.message);
            props.setShowingStatusVoice("Not Connected");
          }
        })
        .catch((error) => {
          ErrorNotification("Voice Status", error.message);
          props.setShowingStatusVoice("Not Connected");
        });
    }
  };

  const updateStatusWithReasonCode = async (value) => {
    if (
      localStorage.getItem("voiceEnable") == "true" &&
      localStorage.getItem("ssoToken")
    ) {
      if (!value) return;
      await axios
        .post(
          AvcUrl +
            `/voice/cct/changeAgentStatusReasonCode?agentId=${localStorage.getItem(
              "agentLoginTerminalId"
            )}&status=Not Ready&reason=${
              value.statusCode == null ? "" : value.statusCode
            }`,
          {},
          {
            headers: {
              ssoToken: localStorage.getItem("ssoToken"),
              "Content-Type": "application/json",
              tenantId: localStorage.getItem("TenantId"),
            },
          }
        )
        .then((res) => {
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };
  const userStatus = async () => {
    await axios
      .post(
        BaseUrl + "/userstatus/userstatuslist",
        {},
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        if (res.data.status) {
          setUserstatus(res.data.data);
        } else {
          setUserstatus([]);
        }
      });
  };
  const toggle = () => {
    props.setshowphonedialer(!props.showphonedialer);
    props.setShowNotification(false);
    props.setShowUserProfile(false);
    setDialedNumber("");
  };
  const ErrorNotification = (headerMsg, msg) => {
    const randomChars = Math.random().toString(36).substring(2, 10);
    const timestamp = new Date().getTime().toString(36);
    const randomId = randomChars + timestamp;
    var newNotification = {
      id: randomId,
      username: headerMsg,
      client_msg: msg,
      from_id: "voice api",
      chatType: "Error Message",
    };
    props.updateNotification(newNotification);
  };

  useEffect(() => {
    const checkApiCall = () => {
      const lastCallTimestamp = localStorage.getItem(
        "VoiceStatuslastApiCallTime"
      );
      const currentTime = Date.now();
      const oneHour = 60 * 60 * 1000;

      if (!lastCallTimestamp || currentTime - lastCallTimestamp >= oneHour) {
        console.log("voice api is not called since 1hr");
        let getCurrentStatus = localStorage.getItem("AgentStatus");
        if (getCurrentStatus != "InCall") {
          changeStatusVoice(getCurrentStatus, getCurrentStatus);
        }
      }
    };
    checkApiCall();
    var interval = setInterval(checkApiCall, 60 * 1000);
    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <>
      <div className="header neo-navbar--sticky">
        <nav
          className="neo-navbar animate__animated animate__fadeInDown"
          style={{
            boxShadow: "gray -2px -8px 16px,",
            minHeight: "49px",
            height: "49px",
          }}
        >
          <div className="neo-nav">
            <div className="neo-badge__navbutton">
              {localStorage.getItem("voiceEnable") == "true" ? (
                <span
                  className="material-symbols-outlined"
                  onClick={() => {
                    toggle();
                  }}
                  style={{
                    display: "block",
                    cursor: "pointer",
                    fontSize: "21px",
                  }}
                >
                  dialpad
                </span>
              ) : (
                <></>
              )}
            </div>

            <div className="neo-badge__navbutton ">
              <button
                className="neo-badge__navbutton--content neo-btn neo-icon-notifications-on"
                onClick={show_notification}
              ></button>
              <span
                className="neo-badge__icon"
                data-badge={props.notification ? props.notification.length : 0}
              ></span>
            </div>

            <div
              className={`neo-nav-status ${
                !readyButton
                  ? "neo-nav-status--connected"
                  : "neo-nav-status--ready"
              }`}
              tabIndex="0"
              onClick={show_userprofile}
            >
              <div className="neo-nav-status-info">
                <p className="mx-1 font-weight-bold1">
                  {localStorage.getItem("NameDisplay")}
                </p>

                <span
                  className={`neo-label timer-ready ${showingStatusClass}`}
                  style={{ fontSize: "9px", padding: "0px 13px" }}
                >
                  {showingStatus}
                </span>
              </div>
              <figure className="neo-avatar" data-initials={agentName}></figure>
            </div>
          </div>
        </nav>

        {!isOnline && (
          <div className="offline-message">
            <span>
              <WifiX size={18} />
            </span>
            <span className="ms-2">
              You're offline, Please check the connection error !
            </span>
          </div>
        )}
        {isOnline && showNotification && (
          <div className="online-message">
            <span>
              <WifiHigh size={18} />
            </span>
            <span className="ms-2">You're Online! Connection is back.</span>
          </div>
        )}
      </div>

      {props.showNotification && (
        <div className="main-notify-cont" style={{ zIndex: 10 }}>
          <div className="content ">
            <span className="head">Notifications</span>
            <span
              className="neo-icon-close"
              onClick={close_notification}
              aria-label="close notification"
            ></span>
            {!props.notification && (
              <div className="notify-body">
                <span
                  className="neo-icon-info"
                  aria-label="info notification"
                ></span>
                <span>No notifications to display</span>
              </div>
            )}

            <div className="notify-content-data mt-2">
              {props.notification &&
                props.notification
                  .slice(0)
                  .reverse()
                  .map((data, index) => {
                    return (
                      <div key={index} className="notifications-div">
                        <span
                          className="notify-close"
                          onClick={() => {
                            props.closeNotify(data.id, props.notification);
                          }}
                        >
                          X
                        </span>
                        <div className="noti-username">
                          {data.username} {`(${data.chatType})`}
                        </div>
                        <div className="noti-msg">
                          <span
                            className="notify-message"
                            title={data.client_msg}
                          >
                            {data.client_msg}
                          </span>
                          <span className="notify-duration">
                            {data.msg_time}
                          </span>
                        </div>
                        <div
                          className=""
                          style={{ position: "fixed", bottom: 5, right: 35 }}
                        >
                          <button
                            className="btn btn-outline-secondary btn-sm"
                            onClick={() => {
                              props.clearnotifyAll(data.id, props.notification);
                              setTimeout(() => {
                                close_notification();
                              }, 1000);
                            }}
                          >
                            Clear all
                          </button>
                        </div>
                      </div>
                    );
                  })}
            </div>
          </div>
        </div>
      )}

      {props.showUserProfile && (
        <div className="main-notify-cont" style={{ zIndex: 10 }}>
          {!showReasonCode && (
            <div className="content">
              <span className="head">Agent Status</span>
              <span className="head_agent-details">
                Agent Id - {agentEmail}
              </span>
              <span
                className="neo-icon-close user-close"
                onClick={close_userprofile}
                aria-label="close notification"
              ></span>

              <Stack sx={{ height: "75vh" }} justifyContent={"space-between"}>
                <div className="user-body">
                  {readyButton == false ? ( //go ready button
                    <button
                      id="go_ready"
                      className="btn btn-success work-start"
                      style={{ fontFamily: "Noto-Sans" }}
                      onClick={() => {
                        setgoReadyButtonDisable(true);
                        loginbyDomain();
                      }}
                      disabled={goReadyButtonDisable}
                    >
                      <span
                        className="neo-icon-work-start"
                        aria-label="start work"
                      ></span>
                      Go Ready
                    </button>
                  ) : (
                    <>
                      <button
                        id="finish_work"
                        className="btn btn-primary"
                        style={{ fontFamily: "Noto-Sans" }}
                        onClick={() => {
                          setgoReadyButtonDisable(true);
                          logoutByDomainFirst();
                        }}
                        disabled={goReadyButtonDisable}
                      >
                        <span
                          className="neo-icon-work-end"
                          aria-label="end work"
                        ></span>
                        Finish Work
                      </button>
                      <div className="status">
                        <div className="status-head">Status</div>
                        <div
                          className="go-not-ready"
                          onClick={() => {
                            userStatus();
                            setshowReasonCode(true);
                          }}
                        >
                          <span
                            className="neo-icon-do-not-disturb"
                            aria-label="end work"
                          ></span>
                          Go Not Ready
                          <span
                            className="neo-icon-chevron-right"
                            aria-label="end work"
                          ></span>
                        </div>

                        <div
                          className="go-ready"
                          style={{ fontFamily: "Noto-Sans" }}
                          onClick={() => {
                            updateStatus("Ready");
                            localStorage.setItem("VoiceCallStatus", "Ready");
                          }}
                        >
                          <span
                            className="neo-icon-go-ready"
                            aria-label="end work"
                          ></span>
                          Go Ready
                        </div>

                        <div
                          className="go-ready"
                          style={{ fontFamily: "Noto-Sans" }}
                          onClick={() => {
                            updateStatus("Not Ready");
                            localStorage.setItem(
                              "VoiceCallStatus",
                              "Not Ready"
                            );
                          }}
                        >
                          <span
                            className="neo-icon-go-ready"
                            aria-label="end work"
                          ></span>
                          Not Ready
                        </div>
                      </div>
                    </>
                  )}

                  <div className="status">
                    <div className="status-head">Channel</div>
                    {filteredChannels
                      ? filteredChannels.map((item, index) => {
                          return (
                            <div key={index} className="go-not-ready">
                              <Stack
                                direction={"row"}
                                alignItems={"center"}
                                justifyContent={"space-between"}
                              >
                                {item.channelName} - {""}
                                {item.channelName == "Voice"
                                  ? showingStatusVoice
                                  : showingStatus}
                                {item.channelName == "Voice" &&
                                readyButton &&
                                showingStatusVoice == "Not Connected" ? (
                                  <ArrowsClockwise
                                    size={17}
                                    onClick={() => {
                                      loginbyDomain();
                                    }}
                                  />
                                ) : null}
                              </Stack>
                            </div>
                          );
                        })
                      : null}
                  </div>
                </div>

                <Stack spacing={0.5}>
                  {readyButton == false && (
                    <Button
                      variant="outlined"
                      color="error"
                      startIcon={<SignOut size={22} />}
                      onClick={logout}
                    >
                      SIGN OUT
                    </Button>
                  )}
                  <Button
                    variant="outlined"
                    color="error"
                    startIcon={<SealCheck size={22} />}
                    disabled
                  >
                    Version: {versionCode}
                  </Button>
                </Stack>
              </Stack>
            </div>
          )}

          {showReasonCode && (
            <div className="contents">
              <div className="status">
                <div className="reason-head">
                  <span
                    className="neo-icon-chevron-left"
                    aria-label="end work"
                    onClick={() => {
                      setshowReasonCode(false);
                    }}
                  ></span>
                  Reason Codes
                </div>
                <div className="content1">
                  {userstatus
                    ? userstatus.map((item, index) => (
                        <div
                          key={index}
                          className="go-not-ready"
                          onClick={() => {
                            updateStatus(item.statusName);
                            updateStatusWithReasonCode(item);
                            setshowReasonCode(false);
                            localStorage.setItem(
                              "VoiceCallStatus",
                              item.statusName
                            );
                          }}
                        >
                          {item.statusName}
                        </div>
                      ))
                    : null}
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      {localStorage.getItem("enableSDK") == "true" ? (
        <Sdk
          setinvoice={setinvoice}
          setDialedNumber={setDialedNumber}
          dailedNumber={dailedNumber}
          changeStatusVoice={changeStatusVoice}
        />
      ) : null}
    </>
  );
};

export default connect(mapStateToProps, {
  setcontactlist,
  setcontactlist1,
  closeNotify,
  clearnotifyAll,
  setShowNotification,
  setShowUserProfile,
  setshowphonedialer,
  setVoiceRefresh,
  setShowingStatusClass,
  setShowingStatus,
  setShowingStatusVoice,
  setsidebarVal,
  setReadyButton,
  updateNotification,
})(Navbar);
